// Descuento de la ficha del producto (H17): el usuario lo escribe en porcentaje y
// el backend lo guarda como FRACCIÓN (0.05 = 5 %), que es lo que la venta y la
// proforma copian tal cual. Antes la ficha guardaba lo tecleado y un «5» se
// volvía 500 % en la venta.
import Big from 'big.js';

function toBig(value) {
    if (value === null || value === undefined || value === '') return new Big(0);
    try {
        return new Big(String(value).replace(',', '.').trim());
    } catch (e) {
        return new Big(0);
    }
}

// 5 -> "0.05", "2,5" -> "0.025". Lo que se manda al backend.
export function percentToFraction(percent) {
    return toBig(percent).div(100).toString();
}

// 0.05 -> 5. Lo que se muestra en el campo «Descuento (%)».
export function fractionToPercent(fraction) {
    return Number(toBig(fraction).times(100).round(2));
}

// 0.05 -> "5 %". La columna de la lista.
export function formatPercent(fraction) {
    return `${fractionToPercent(fraction)} %`;
}
